import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';

class DigestCallback extends Component {
    static propTypes = {
        currentUserProfile: PropTypes.object,
        loading: PropTypes.bool
    };

    getCollectionId = () => {
        const { currentUserProfile } = this.props;
        if (currentUserProfile && currentUserProfile.currentUserCollection) {
            return (
                currentUserProfile.currentUserCollection.currentCollectionPermalink ||
                currentUserProfile.currentUserCollection.currentCollectionId
            );
        }
        return '';
    };

    render() {
        const { loading, currentUserProfile } = this.props;
        const currentCollectionId = this.getCollectionId();
        if (currentCollectionId && !loading && currentUserProfile) {
            return <Redirect to={`/collection/${currentCollectionId}`} />;
        }
        if (!currentCollectionId && !loading && currentUserProfile) {
            return <Redirect to={`/home`} />;
        }
        return <div>test</div>;
    }
}

export const mapStateToProps = (state) => {
    const {
        auth: { loggedInUserId },
        profiles
    } = state;
    return {
        currentUserProfile: profiles.byId[loggedInUserId],
        loading: profiles.loading
    };
};

export const mapDispatchToProps = () => ({});

export const DigestCallbackComponent = DigestCallback;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigestCallback));
